import { useDispatch } from 'react-redux'
import { useGetConnectivity } from '../../../Flux/Selector/Application/GetConnectivitySelector.js'
import { checkConnectivityNow } from '../../../Flux/Slice/Application/ApplicationSlice.js'

/*
 * The user-facing half of the connectivity layer: says why live updates stopped,
 * and offers an immediate retry instead of making people guess whether anything
 * is still trying. Renders nothing while online.
 */
export const ConnectivityBanner = () => {
  const { status, probing, lastCheckedAt } = useGetConnectivity()
  const dispatch = useDispatch()

  if (status === 'online') return null

  return (
    <div className="alert alert-warning rounded-none flex flex-wrap items-center justify-between gap-2 px-4" role="alert" data-testid="connectivity-banner">
      <div className="flex flex-col">
        <span>No connection to the server — live updates are paused. Retrying automatically.</span>
        {lastCheckedAt && <span className="text-xs opacity-70">Last checked {new Date(lastCheckedAt).toLocaleTimeString()}</span>}
      </div>
      <button className="btn btn-sm" disabled={probing} onClick={() => dispatch(checkConnectivityNow())} data-testid="connectivity-check-now">
        {probing ? 'Checking…' : 'Check now'}
      </button>
    </div>
  )
}
